var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoPlaceholder = function SvgLogoPlaceholder(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#2196F3",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 26.667C7.33833 26.277 11.0617 26.1787 14.9083 27.072M26.6667 35.0003C23.8267 30.387 19.2883 28.087 14.9083 27.072M14.9083 27.072C18.1583 23.3087 24.2633 20.0003 35 20.0003H36.6667M14.1667 11.667C13.3333 11.667 11.6667 12.167 11.6667 14.167C11.6667 16.167 13.3333 16.667 14.1667 16.667C15 16.667 16.6667 16.167 16.6667 14.167C16.6667 12.167 15 11.667 14.1667 11.667Z",
    stroke: "#8F9294",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6663 20.0002C36.6663 29.2052 29.2047 36.6668 19.9997 36.6668C10.7947 36.6668 3.33301 29.2052 3.33301 20.0002C3.33301 10.7952 10.7947 3.3335 19.9997 3.3335M31.6663 3.3335V8.3335M31.6663 13.3335V8.3335M31.6663 8.3335H36.6663M31.6663 8.3335H26.6663",
    stroke: "#8F9294",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "logo-placeholder.3cc256596d918da6ad8869fd7267609f.svg";